import React from "react";

import {
  HEADER_COPY,
  BODY_COPY,
  CTA_COPY,
  CTA_LINK
} from "../../../utils/content-keys";
import "./in-touch.scss";

const InTouch = ({ content }) => {
  return (
    <div className="in-touch">
      <h3 className="in-touch__headline">{content[HEADER_COPY].value}</h3>
      {/* <p className="in-touch__copy in-touch__copy--lg">+353 1 471 2455</p> */}
      <p className="in-touch__copy">{content[BODY_COPY].value}</p>
      <a href={content[CTA_LINK].value} className="cta in-touch__cta">
        {content[CTA_COPY].value}
      </a>
    </div>
  );
};

export default InTouch;



// WEBPACK FOOTER //
// ./src/pages/faqs/InTouch/index.js